







































import {UserRole} from '@/interfaces/server-data';
import {EventBus} from '@/mixins/event-bus';
import Http from '@/mixins/http';
import {Component, Mixins, Watch} from 'vue-property-decorator';
import LocalData from './mixins/local-data';
import Sidebar from "@/components/UI/Sidebar.vue";
import {isLoginPage} from "@/utils/isLoginPage";
import {isAuthCallbackPage} from "@/utils/isAuthCallbackPage";
import Auth from "@/pages/Auth/Auth.vue";
import AuthCallback from "@/pages/Auth/AuthCallback.vue";
import { Modal } from 'ant-design-vue';
import {keycloakAuthService} from "@/services/keycloakAuth";
import NotificationDrawer from "@/components/UI/NotificationDrawer.vue";
import AiAssistantDrawer from "@/components/UI/AiAssistantDrawer.vue";
import { getEnv } from "@/runtime-config";
import { getRouterList, RouteItem } from "@/config/routerList";
import { syncMomentLocale, getAntDatePickerLocale } from '@/i18n/dateLocale';
// @ts-ignore
import antRu from 'ant-design-vue/es/locale-provider/ru_RU';
// @ts-ignore
import antEn from 'ant-design-vue/es/locale-provider/en_US';
// @ts-ignore
import antEs from 'ant-design-vue/es/locale-provider/es_ES';
// @ts-ignore
import antDe from 'ant-design-vue/es/locale-provider/de_DE';

@Component({
    methods: {isLoginPage, isAuthCallbackPage},
    components: { Auth, Sidebar, AuthCallback, NotificationDrawer, AiAssistantDrawer },
})
export default class App extends Mixins(LocalData, Http) {
    isShow: boolean = false;
    isMainSpinnerLoading: boolean = false;

    sidebarCollapsed: boolean = true;

    ws!: WebSocket;
    routerList: RouteItem[] = getRouterList();

    private antdLocaleMap: Record<string, any> = { ru: antRu, en: antEn, es: antEs, de: antDe };

    get antdLocale() {
        return this.antdLocaleMap[this.$i18n.locale] || antRu;
    }

    @Watch('$i18n.locale')
    onLocaleChanged() {
        syncMomentLocale();
    }

    handleLogoutBtnClick() {
        Modal.confirm({
            title: this.$t('app.titles.confirmLogout') as string,
            content: this.$t('app.text.confirmLogoutMessage') as string,
            centered: true,
            okText: this.$t('app.buttons.yesLogout') as string,
            cancelText: this.$t('app.buttons.cancel') as string,
            onOk: () => {
                this.isMainSpinnerLoading = true;

                this.logout();
            },
        });
    }

    logout() {
        if (getEnv('AUTH_MODE') === 'keycloak') {
            keycloakAuthService.logout().then((json) => {
                this.$log.debug('logout success', json);
            })
            .catch((error) => {
                this.$log.debug('logout error', error);
            })
            .finally(() => {
                setTimeout(() => {
                    this.showInfo(this.$t('app.messages.redirectToLogin') as string);
                }, 1000);

                setTimeout(() => {
                    this.resetDataAfterLogout();

                    this.isMainSpinnerLoading = false;

                    window.history.replaceState(null, '', '/login');
                }, 3000);
            });
        } else {
            this.$http.post('logout', null)
                .then((json) => {
                    this.$log.debug('logout success', json);
                })
                .catch((error) => {
                    this.$log.debug('logout error', error);
                })
                .finally(() => {
                    setTimeout(() => {
                        this.showInfo(this.$t('app.messages.redirectToLogin') as string);
                    }, 1000);

                    setTimeout(() => {
                        this.resetDataAfterLogout();

                        this.isMainSpinnerLoading = false;

                        window.history.replaceState(null, '', '/login');
                    }, 3000);
                });
        }
    }

    resetDataAfterLogout() {
        this.resetCalcData();
        this.resetPreCalcData();
        this.resetRoundingRulesData()
        this.resetSetupMasterCalcData();
        this.resetPromoData();
        this.resetSalesData();
        this.resetPromotionsData();
        this.resetPackagePromoRecommendsData();
        this.resetPackageCalcData();
        this.resetPackagePromoData();
        this.resetScheduleCalcData();
        this.resetKviShoppingCartData();
        this.resetPackageKviRecommendsData();
        this.resetPackageParamsInDetailReportData();
        this.resetScenarioAnalysisData();
        this.resetEventsData();
        this.resetResultsMonitorData();
        localStorage.removeItem('AUTH');
        localStorage.removeItem('userData');
        localStorage.removeItem('sp_notifications');
    }

    connect() {
        this.$log.debug('App');
        let wsPr = 'ws'
        if (location.protocol === 'https:') {
            wsPr = 'wss'
        }
        this.ws = new WebSocket(`${wsPr}://${window.location.host}/ws/`)
        this.ws.onopen = () => {
            this.$log.info('Web socket open');
            this.$log.debug('ws.onopen', this.ws);
            this.$log.debug(this.ws.readyState, 'websocketstatus');
        };
        this.ws.onclose = (e) => {
            this.$log.debug('ws.onclose', e);
        };
        this.ws.onerror = (e) => {
            this.$log.debug('ws.onerror', e);
        };
        this.ws.onmessage = (e) => {
            const data = JSON.parse(e.data);
            if (data.type === 'ping') {
            } else {
                this.$log.debug('ws.onmessage', e);
            }
            if (data.type === 'task') {
                if (data.session) {
                    this.ws.send('change task status');
                } else {
                    EventBus.$emit('calc', data.data);
                }
            } else if (data.type === 'file') {
                EventBus.$emit('file', data.data);
            } else if (data.type === 'downloadProgress') {
                EventBus.$emit('downloadProgress', data.data);
            } else if (data.type === 'ftpDownloadProgress') {
                EventBus.$emit('ftpDownloadProgress', data.data);
            } else {
                this.ws.send('pong');
            }
        };
    }

    closeSocket() {
        this.$log.debug('closeSocket');
        if (this.ws != null) {
            this.ws.close();
        }
    }

    initFiltersSuperset() {
        const checkFilter = localStorage.getItem('FILTERS_SUPERSET');
        const filters = {
            GROUP: '',
            CATEGORY: '',
            SUB_CATEGORY: '',
            FORMAT: '',
            REGION: '',
            CLASTER: '',
            COMPANY: '',
        };

        if (!checkFilter) {
            localStorage.setItem('FILTERS_SUPERSET', JSON.stringify(filters))
        }
    }

    created() {
        if (isLoginPage() || isAuthCallbackPage()) return;

        this.initFiltersSuperset()
        this.setCalcData();
        this.setPreCalcData();
        this.setSetupMasterCalcData();
        this.setEventsData();
        this.setResultsMonitorData();
        this.setRevaluationData();
        this.setPromoData();
        this.setSalesData();
        this.setPromotionsData();
        this.setPackageCalcData();
        this.setPackagePromoData();
        this.setPackagePromoRecommendsData();
        this.setKviShoppingCartData();
        this.setPackageKviRecommendsData();
        this.setPackageParamsInDetailReportData();
        this.setScenarioAnalysisData();
        this.setScheduleCalcData();
        this.setRoundingRulesData();
        this.connect();
        window.onbeforeunload = this.closeSocket;
    }

    mounted() {
        if (isLoginPage() || isAuthCallbackPage()) return;

        this.initApp();
    }

    initApp() {
        const hasSetUpdateFrequency = localStorage.getItem('hasSetUpdateFrequency');
        if (!hasSetUpdateFrequency) {
            localStorage.setItem('updateFrequency', '5');
            localStorage.setItem('hasSetUpdateFrequency', 'true');
        }
        this.httpGetConfig()
            .then((r) => {
                if (r.status === 200) {
                    this.$disallowedModules.push(...r.data.disallowedModules);
                    this.$disallowedModules.forEach((m) => {
                        this.routerList.forEach((routerValue) => {
                            if (routerValue.child && Array.isArray(routerValue.child)) {
                                routerValue.child.forEach((childValue: RouteItem, idx: number) => {
                                    if (childValue.module && childValue.module === m) {
                                        routerValue.child!.splice(idx, 1)
                                    }
                                });
                            }
                        });
                        const index = this.routerList.findIndex((route) => {
                            return typeof route.module === 'string' && route.module === m;
                        });
                        if (index !== -1) {
                            this.routerList.splice(index, 1);
                        }
                    });
                    this.$userRole = r.data.role;
                    this.$accessToSystemParams = r.data.accessToSystemParams;
                    this.$permissions = r.data.permissions;
                    this.$additionalRoles = r.data.additionalRoles || [];

                    // Проверки доступа к основным модулям системы
                    if (!this.$permissions.includes('RESULTS_MONITOR')) {
                        const index = this.routerList.findIndex((item) => {
                            return item.module === 'result-monitor'
                        });
                        if (index !== -1) {
                            this.routerList.splice(index, 1);
                        }
                    }
                    if (!this.$permissions.includes('KPI_DASHBOARD')) {
                        const index = this.routerList.findIndex((item) => {
                            return item.module === 'kpi-panel'
                        });
                        if (index !== -1) {
                            this.routerList.splice(index, 1);
                        }
                    }
                    if (!this.$permissions.includes('REGULAR_PRICES')) {
                        const index = this.routerList.findIndex((item) => {
                            return item.id === 'Calc'
                        });
                        if (index !== -1) {
                            this.routerList.splice(index, 1);
                        }
                    }
                    if (!this.$permissions.includes('PACKAGE_CALCULATION')) {
                        const index = this.routerList.findIndex((item) => {
                            return item.id === 'PackageCalc'
                        });
                        if (index !== -1) {
                            this.routerList.splice(index, 1);
                        }
                    }
                    if (!this.$permissions.includes('SALES')) {
                        const index = this.routerList.findIndex((item) => {
                            return item.module === 'sales'
                        });
                        if (index !== -1) {
                            this.routerList.splice(index, 1);
                        }
                    }
                    if (!this.$permissions.includes('RESULTS')) {
                        const index = this.routerList.findIndex((item) => {
                            return item.id === 'Report'
                        });
                        if (index !== -1) {
                            this.routerList.splice(index, 1);
                        }
                    }
                    if (!this.$permissions.includes('EXPORT_DATA')) {
                        const index = this.routerList.findIndex((item) => {
                            return item.module === 'data-export'
                        });
                        if (index !== -1) {
                            this.routerList.splice(index, 1);
                        }
                    }
                    if (!this.$permissions.includes('KVI_CARTS')) {
                        const index = this.routerList.findIndex((item) => {
                            return item.module === 'kviShoppingCart'
                        });
                        if (index !== -1) {
                            this.routerList.splice(index, 1);
                        }
                    }
                    if (!this.$permissions.includes('REVALUATION')) {
                        const index = this.routerList.findIndex((item) => {
                            return item.module === 'revaluation'
                        });
                        if (index !== -1) {
                            this.routerList.splice(index, 1);
                        }
                    }
                    if (!this.$permissions.includes('EVENTS')) {
                        const index = this.routerList.findIndex((item) => {
                            return item.module === 'events'
                        });
                        if (index !== -1) {
                            this.routerList.splice(index, 1);
                        }
                    }
                    if (!this.$permissions.includes('SETTINGS')) {
                        const index = this.routerList.findIndex((item) => {
                            return item.module === 'settings'
                        });
                        if (index !== -1) {
                            this.routerList.splice(index, 1);
                        }
                    }
                    if (!this.$permissions.includes('PROMO')) {
                        const index = this.routerList.findIndex((item) => {
                            return item.module === 'promo'
                        });
                        if (index !== -1) {
                            this.routerList.splice(index, 1);
                        }
                    }
                    if (!this.$permissions.includes('SCENARIO_ANALYSIS')) {
                        const index = this.routerList.findIndex((item) => {
                            return item.module === 'scenarioAnalysis'
                        });
                        if (index !== -1) {
                            this.routerList.splice(index, 1);
                        }
                    }
                    if (!this.$permissions.includes('OMNICHANNEL_STRATEGY')) {
                        const index = this.routerList.findIndex((item) => {
                            return item.module === 'omnichannelStrategy'
                        });
                        if (index !== -1) {
                            this.routerList.splice(index, 1);
                        }
                    }
                    // Проверка доступа к модулю Загрузки
                    const hasGeneralUploadsAccess = this.$permissions.includes('UPLOADS');
                    const uploadsSubmodules = [
                        'UPLOADS_SALES',
                        'UPLOADS_COMPETITORS',
                        'UPLOADS_LASTPRICES',
                        'UPLOADS_KVI_CARTS',
                        'UPLOADS_PROMO'
                    ];

                    const hasSubmoduleAccess = uploadsSubmodules.some(submodule =>
                        this.$permissions.includes(submodule)
                    );

                    if (!hasGeneralUploadsAccess && !hasSubmoduleAccess) {
                        // Удаляем модуль Загрузки если нет доступа ни к общему модулю, ни к подмодулям
                        const index = this.routerList.findIndex((item) => {
                            return item.module === 'uploads'
                        });
                        if (index !== -1) {
                            this.routerList.splice(index, 1);
                        }
                    } else if (!hasGeneralUploadsAccess && hasSubmoduleAccess) {
                        // Если есть доступ только к подмодулям, фильтруем дочерние элементы
                        const uploadsModuleIndex = this.routerList.findIndex((item) => {
                            return item.module === 'uploads'
                        });

                        if (uploadsModuleIndex !== -1 && this.routerList[uploadsModuleIndex].child) {
                            const filteredChildren = this.routerList[uploadsModuleIndex].child!.filter((child) => {
                                // Проверяем доступ к конкретным подмодулям
                                if (child.id === 'Files') return this.$permissions.includes('UPLOADS_SALES');
                                if (child.id === 'CompetitorsFiles') return this.$permissions.includes('UPLOADS_COMPETITORS');
                                if (child.id === 'LastPricesFiles') return this.$permissions.includes('UPLOADS_LASTPRICES');
                                if (child.id === 'PromoFiles') return this.$permissions.includes('UPLOADS_PROMO');
                                if (child.id === 'KviShoppingCart') return this.$permissions.includes('UPLOADS_KVI_CARTS');

                                return false;
                            });

                            this.routerList[uploadsModuleIndex].child = filteredChildren;
                        }
                    }
                    // При общем доступе к UPLOADS все дочерние элементы остаются доступными
                    // Проверка доступа к модулю Фиксированные цены
                    const hasFixedPricesAccess = this.$permissions.includes('FIXED_PRICES');
                    if (!hasFixedPricesAccess) {
                        const index = this.routerList.findIndex((item) => {
                            return item.module === 'fixedPrices'
                        });
                        if (index !== -1) {
                            this.routerList.splice(index, 1);
                        }
                    }
                    if (!this.$permissions.includes('SUPPORT_PAGE')) {
                        const index = this.routerList.findIndex((item) => {
                            return item.module === 'support'
                        });
                        if (index !== -1) {
                            this.routerList.splice(index, 1);
                        }
                    }
                    this.$userId = r.data.userId;
                    this.$log.debug('App', this.$userRole);
                    this.routerList = this.routerList.filter((route) => {
                        return typeof route.role === 'undefined' || route.role === this.$userRole;
                    })
                }
                this.isShow = true;
            })
            .catch((e) => {
                this.isShow = true;
                this.showError(this.$t('app.errors.loadAppSettings') as string)
            })
    }
}
